import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/context';
import { ROUTES } from '@/constants';
import PageLoader from '@/components/PageLoader';

function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <PageLoader message="Checking authentication..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  return <Outlet />;
}

export default ProtectedRoute;
